import { useContext } from "react";
import { UserContext } from "../contexts/user.context";

export default function useCSSVars() {
  const { isUser, userData } = useContext(UserContext);

  function hexToRgba(hex: string, opacity: number): string {
    // Remove the hash if it exists
    hex = hex?.replace(/^#/, "");

    // Check if it's a valid hex color code
    if (!/^[0-9A-Fa-f]{3,6}$/.test(hex)) {
      throw new Error("Invalid hex color code");
    }

    // If the hex code has an odd number of digits, duplicate each digit
    if (hex.length % 2 !== 0) {
      hex = hex
        .split("")
        .map((char) => char + char)
        .join("");
    }

    // Parse the hex values to separate R, G, and B values
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    // Return the rgba representation with the specified opacity
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  document.documentElement.style.setProperty(
    "--item-background-color",
    userData[0]?.asdc_client?.itemBackgroudnColor,
  );
  if (userData[0]?.asdc_client?.itemBackgroudnColor) {
    document.documentElement.style.setProperty(
      "--secondary-item-background-color",
      hexToRgba(userData[0]?.asdc_client?.itemBackgroudnColor, 0.3),
    );
  }
  if (userData[0]?.asdc_client?.itemBackgroudnColor) {
    document.documentElement.style.setProperty(
      "--secondary-1-color",
      hexToRgba(userData[0]?.asdc_client?.itemBackgroudnColor, 0.1),
    );
  }
  if (userData[0]?.asdc_client?.itemBackgroudnColor) {
    document.documentElement.style.setProperty(
      "--secondary-2-color",
      hexToRgba(userData[0]?.asdc_client?.itemBackgroudnColor, 0.2),
    );
  }
  if (userData[0]?.asdc_client?.backgroudnColor) {
    document.documentElement.style.setProperty(
      "--secondary-background-color",
      hexToRgba(userData[0]?.asdc_client?.backgroudnColor, 0.2),
    );
  }
  document.documentElement.style.setProperty(
    "--background-color",
    userData[0]?.asdc_client?.backgroudnColor,
  );
  document.documentElement.style.setProperty(
    "--image-color",
    userData[0]?.asdc_client?.imageColor,
  );

  if (userData[0]?.asdc_client?.textColor) {
    document.documentElement.style.setProperty(
      "--secondary-text-color",
      hexToRgba(userData[0]?.asdc_client?.textColor, 0.55),
    );
  }
  document.documentElement.style.setProperty(
    "--text-color",
    userData[0]?.asdc_client?.textColor,
  );

  if (isUser) {
    document.body.style.backgroundColor = "var(--background-color)";
  }
}
